export const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export const MONTH_MAP = {
    jan: 'JANUARY',   feb: 'FEBRUARY', mar: 'MARCH',     apr: 'APRIL',
    may: 'MAY',       jun: 'JUNE',     jul: 'JULY',      aug: 'AUGUST',
    sep: 'SEPTEMBER', oct: 'OCTOBER',  nov: 'NOVEMBER',  dec: 'DECEMBER',
};

export const VALUE_COLUMNS = ['total', ...MONTHS];
